var DIABEC_API_BASE = (window.DIABEC_API_BASE || 'https://diabec-website.pages.dev');
/*
 * Diabec Voice Agent — client controller.
 * Mounts a floating "Talk to AI" button. On click → consent modal → mints a
 * LiveKit guest token from /api/voice-token, connects via WebRTC, then asks
 * /api/voice-start to dispatch Pearl into the room via SIP.
 *
 * Loaded on diabec-homepage-draft.html. Depends on global LivekitClient (UMD
 * bundle from cdn.jsdelivr.net/npm/livekit-client). Degrades gracefully:
 * if Pages Functions aren't reachable, surfaces a tel: fallback toast.
 */
(function () {
    'use strict';

    if (window.__diabecVoiceAgentMounted) return;
    window.__diabecVoiceAgentMounted = true;

    var PEARL_TEL = '+13124711541';

    // ─────────── State ───────────
    var state = {
        room: null,
        roomName: null,
        timer: null,
        startedAt: null,
        connecting: false,
        muted: false,
    };

    // ─────────── DOM builders ───────────
    var PHONE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97a15.547 15.547 0 01-6.99-6.99l1.95-1.57c.27-.27.35-.65.24-1.01-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 2.94 3 3.18 3 3.93 3 13.28 10.72 21 20.07 21c.71 0 .93-.63.93-1.18v-3.44c0-.55-.45-1-.99-1z"/></svg>';
    var MIC_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 14a3 3 0 003-3V6a3 3 0 10-6 0v5a3 3 0 003 3zm5-3a5 5 0 01-10 0H5a7 7 0 006 6.92V21h2v-3.08A7 7 0 0019 11h-2z"/></svg>';
    var MIC_OFF_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zM14.98 11.17c0-.06.02-.11.02-.17V5a3 3 0 00-5.94-.6L14.98 11.17zM4.27 3L3 4.27l6.01 6.01V11a3 3 0 003 3c.22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52a5 5 0 01-5-5H5a7 7 0 0011.21 5.6L19.73 21 21 19.73 4.27 3z"/></svg>';
    // ─────────── Fetch helpers ───────────
    function abortFetch(url, opts, ms) {
        var ctrl = new AbortController();
        var tid = setTimeout(function () { ctrl.abort(); }, ms);
        return fetch(url, Object.assign({ signal: ctrl.signal }, opts))
            .then(function (r) { clearTimeout(tid); return r; })
            .catch(function (e) { clearTimeout(tid); throw e; });
    }
    function fetchWithRetry(url, opts, ms) {
        var isMobile = window.innerWidth <= 768;
        var timeout = ms || (isMobile ? 6000 : 8000);
        var attempt = function (i) {
            return abortFetch(url, opts, timeout).catch(function (e) {
                if (i >= 1 || (e && e.name === 'AbortError')) throw e;
                return new Promise(function (res) { setTimeout(res, 800); }).then(function () { return attempt(i + 1); });
            });
        };
        return attempt(0);
    }



    function el(tag, attrs, html) {
        var n = document.createElement(tag);
        if (attrs) {
            for (var k in attrs) {
                if (k === 'class') n.className = attrs[k];
                else if (k === 'text') n.textContent = attrs[k];
                else n.setAttribute(k, attrs[k]);
            }
        }
        if (html !== undefined) n.innerHTML = html;
        return n;
    }

    // ─────────── FAB ───────────
    function buildFab() {
        var btn = el('button', {
            class: 'dva-fab dva-fab-pulse',
            type: 'button',
            'aria-label': 'Talk to our AI voice assistant (Pearl) — opens a consent dialog before connecting',
            'aria-haspopup': 'dialog',
            'title': 'AI Voice Assistant',
        });
        btn.innerHTML = PHONE_ICON + '<span class="dva-fab-badge">AI</span><span class="dva-fab-tooltip" aria-hidden="true">AI Voice Assistant</span>';
        btn.addEventListener('click', openConsentModal);
        return btn;
    }

    // ─────────── Consent modal ───────────
    var modalEl = null;
    function buildModal() {
        var overlay = el('div', {
            class: 'dva-modal-overlay',
            role: 'dialog',
            'aria-modal': 'true',
            'aria-labelledby': 'dva-modal-title',
        });
        var modal = el('div', { class: 'dva-modal' });
        modal.appendChild(el('h2', { id: 'dva-modal-title', text: 'Speak with our AI assistant' }));
        modal.appendChild(el('p', { text: "Tap below to start a free voice conversation with Pearl, Diabec's AI assistant. You'll need to allow microphone access." }));
        var disc = el('div', { class: 'dva-disclaimer' });
        disc.innerHTML = '<strong>AI disclosure (EU AI Act Art. 50):</strong> You are about to speak with an AI voice agent, not a human. Pearl can answer questions about Diabec but is not a medical professional and cannot diagnose, treat, or advise on medication. In a medical emergency, call your local emergency number (e.g. 999 UK, 911 US, 000 AU, 911 CA). Diabec is a food supplement, not a medicine.';
        modal.appendChild(disc);

        var actions = el('div', { class: 'dva-modal-actions' });
        var cancel = el('button', { class: 'dva-btn dva-btn-secondary', type: 'button', text: 'Cancel' });
        var start = el('button', { class: 'dva-btn dva-btn-primary', type: 'button', text: 'Start call' });
        cancel.addEventListener('click', closeModal);
        start.addEventListener('click', startCall);
        actions.appendChild(cancel);
        actions.appendChild(start);
        modal.appendChild(actions);

        overlay.appendChild(modal);
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) closeModal();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && overlay.classList.contains('dva-open')) closeModal();
        });
        return overlay;
    }

    function openConsentModal() {
        modalEl.classList.add('dva-open');
        var first = modalEl.querySelector('.dva-btn-primary');
        if (first) first.focus();
    }
    function closeModal() {
        modalEl.classList.remove('dva-open');
    }

    // ─────────── Call panel ───────────
    var panelEl = null;
    var panelTitle = null;
    var panelTimer = null;
    var panelMic = null;
    var panelEnd = null;

    function buildPanel() {
        var panel = el('div', { class: 'dva-call-panel', role: 'status', 'aria-live': 'polite' });
        var status = el('div', { class: 'dva-call-status' });
        panelTitle = el('div', { class: 'dva-call-title', text: 'Connecting…' });
        panelTimer = el('div', { class: 'dva-call-timer', text: '' });
        status.appendChild(panelTitle);
        status.appendChild(panelTimer);

        panelMic = el('button', { class: 'dva-mic-indicator', type: 'button', 'aria-label': 'Mute microphone' });
        panelMic.innerHTML = MIC_ICON;
        panelMic.addEventListener('click', toggleMute);

        panelEnd = el('button', { class: 'dva-end-btn', type: 'button', text: 'End' });
        panelEnd.addEventListener('click', endCall);

        panel.appendChild(status);
        panel.appendChild(panelMic);
        panel.appendChild(panelEnd);
        return panel;
    }

    function showPanel() { panelEl.classList.add('dva-open'); }
    function hidePanel() { panelEl.classList.remove('dva-open'); }
    function setPanelTitle(t) { panelTitle.textContent = t; }

    // ─────────── Toast ───────────
    function toast(msg, ms) {
        var t = el('div', { class: 'dva-toast', role: 'alert' });
        t.textContent = msg;
        document.body.appendChild(t);
        setTimeout(function () { t.remove(); }, ms || 5000);
    }

    // ─────────── Call lifecycle ───────────
    async function startCall() {
        if (state.connecting || state.room) return;
        closeModal();
        showPanel();
        setPanelTitle('Connecting…');
        panelTimer.innerHTML = '<span class="dva-spinner"></span>Calling Pearl…';
        state.connecting = true;

        if (!window.LivekitClient) {
            failCall('Voice service is loading — please try again in a moment.');
            return;
        }

        try {
            // 1) Mint guest token
            var tokenRes = await fetchWithRetry(DIABEC_API_BASE + '/api/voice-token', { method: 'POST' });
            if (tokenRes.status === 429) {
                var retryAfter = tokenRes.headers.get('Retry-After') || '60';
                failCall('Our lines are busy. Try again in ' + retryAfter + 's or call ' + PEARL_TEL + '.');
                return;
            }
            if (!tokenRes.ok) throw new Error('voice-token ' + tokenRes.status);
            var tokenData = await tokenRes.json();
            state.roomName = tokenData.room;

            // 2) Connect WebRTC
            var room = new window.LivekitClient.Room({ adaptiveStream: true, dynacast: true });
            state.room = room;
            room.on(window.LivekitClient.RoomEvent.ParticipantConnected, onParticipantJoined);
            room.on(window.LivekitClient.RoomEvent.Disconnected, onDisconnected);
            room.on(window.LivekitClient.RoomEvent.TrackSubscribed, onTrackSubscribed);

            await room.connect(tokenData.url, tokenData.token);
            await room.localParticipant.setMicrophoneEnabled(true);

            // 3) Dispatch Pearl
            var startRes = await fetchWithRetry(DIABEC_API_BASE + '/api/voice-start', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ room: tokenData.room }),
            });
            if (startRes.status === 429) {
                var retryAfterStart = startRes.headers.get('Retry-After') || '60';
                failCall('Our AI is at capacity. Try again in ' + retryAfterStart + 's or call ' + PEARL_TEL + '.');
                return;
            }
            if (!startRes.ok) throw new Error('voice-start ' + startRes.status);

            setPanelTitle('Pearl is joining…');

        } catch (err) {
            console.error('[dva] startCall failed', err);
            if (err && err.name === 'NotAllowedError') {
                failCall('Microphone permission denied. Enable mic access in your browser to talk.');
            } else {
                failCall("We couldn't start the call. You can call us at " + PEARL_TEL + ".");
            }
        }
    }

    function onParticipantJoined(participant) {
        // Pearl joined the room via SIP
        state.connecting = false;
        state.startedAt = Date.now();
        setPanelTitle('Connected with Pearl');
        if (state.timer) clearInterval(state.timer);
        state.timer = setInterval(updateTimer, 1000);
        updateTimer();
    }

    function onTrackSubscribed(track, _publication, _participant) {
        if (track.kind === 'audio') {
            var audio = track.attach();
            audio.setAttribute('autoplay', '');
            audio.style.display = 'none';
            document.body.appendChild(audio);
        }
    }

    function updateTimer() {
        if (!state.startedAt) return;
        var s = Math.floor((Date.now() - state.startedAt) / 1000);
        var mm = String(Math.floor(s / 60)).padStart(2, '0');
        var ss = String(s % 60).padStart(2, '0');
        panelTimer.textContent = mm + ':' + ss;
    }

    function toggleMute() {
        if (!state.room) return;
        state.muted = !state.muted;
        state.room.localParticipant.setMicrophoneEnabled(!state.muted);
        panelMic.classList.toggle('dva-muted', state.muted);
        panelMic.innerHTML = state.muted ? MIC_OFF_ICON : MIC_ICON;
        panelMic.setAttribute('aria-label', state.muted ? 'Unmute microphone' : 'Mute microphone');
    }

    async function endCall() {
        if (state.room) {
            try { await state.room.disconnect(); } catch (_) { /* ignore */ }
        }
        if (state.roomName) {
            // Best-effort: tell server to tear down the SIP leg
            fetch(DIABEC_API_BASE + '/api/voice-end', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ room: state.roomName }),
                keepalive: true,
            }).catch(function () { /* ignore */ });
        }
    }

    function onDisconnected(reason) {
        if (reason && reason !== 'CLIENT_INITIATED') {
            toast('Connection lost — try again or call ' + PEARL_TEL + '.', 5000);
        }
        cleanup();
    }

    function failCall(msg) {
        toast(msg, 7000);
        cleanup();
    }

    function cleanup() {
        if (state.timer) { clearInterval(state.timer); state.timer = null; }
        state = { room: null, roomName: null, timer: null, startedAt: null, connecting: false, muted: false };
        hidePanel();
        panelTimer.textContent = '';
        panelMic.classList.remove('dva-muted');
        panelMic.innerHTML = MIC_ICON;
        panelMic.setAttribute('aria-label', 'Mute microphone');
    }

    // ─────────── Cookie-banner clearance ───────────
    // Keeps the FAB above any fixed bottom banner (cookie consent, etc.)
    // so it remains tappable before the user interacts with the banner.
    var fabEl = null;
    var BANNER_SELECTORS = ['#cookieConsent', '.cookie-consent', '[id*="cookie"][class*="consent"]'];
    var BASE_BOTTOM_PX = 16;

    function getBannerHeight() {
        for (var i = 0; i < BANNER_SELECTORS.length; i++) {
            var b = document.querySelector(BANNER_SELECTORS[i]);
            if (b && getComputedStyle(b).display !== 'none' && b.offsetHeight > 0) {
                return b.offsetHeight;
            }
        }
        return 0;
    }

    function updateFabClearance() {
        if (!fabEl) return;
        var bannerH = getBannerHeight();
        var gap = bannerH > 0 ? BASE_BOTTOM_PX + bannerH + 8 : BASE_BOTTOM_PX;
        var safeArea = 'env(safe-area-inset-bottom, 0px)';
        var val = 'calc(' + gap + 'px + ' + safeArea + ')';
        fabEl.style.bottom = val;
        if (panelEl) panelEl.style.bottom = val;
    }

    function watchBanner() {
        updateFabClearance();
        // Re-measure when banner appears / disappears / resizes
        var mo = new MutationObserver(updateFabClearance);
        mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
        if (typeof ResizeObserver !== 'undefined') {
            BANNER_SELECTORS.forEach(function (sel) {
                var b = document.querySelector(sel);
                if (b) new ResizeObserver(updateFabClearance).observe(b);
            });
        }
    }

    // ─────────── Mount ───────────
    function mount() {
        fabEl = buildFab();
        modalEl = buildModal();
        panelEl = buildPanel();
        document.body.appendChild(fabEl);
        document.body.appendChild(modalEl);
        document.body.appendChild(panelEl);
        watchBanner();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mount);
    } else {
        mount();
    }
})();
